<template>
  import { setTimeout } from 'timers';
  <div class="p_d p_t">
    <TopHead title="课程详情" :isWhite="true"></TopHead>
    <div class="pd_t">
      <!--顶部轮播-->
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-if="info.commodityCoverOne">
          <van-image fit="cover" :src="info.commodityCoverOne"/>
        </van-swipe-item>
        <van-swipe-item v-if="info.commodityCoverTwo">
          <van-image fit="cover" :src="info.commodityCoverTwo"/>
        </van-swipe-item>
        <van-swipe-item v-if="info.commodityCoverThree">
          <van-image fit="cover" :src="info.commodityCoverThree"/>
        </van-swipe-item>
      </van-swipe>
      <div class="tag_out">
        <!-- <span class="tag" :style="{backgroundColor : info.bgColor}">{{info.commodityTypeName}}</span> -->
        <span>{{info.commodityName}}</span>
      </div>
      <div class="time">
        主要负责人：
        <span>{{info.duration}}</span>
      </div>
    </div>
    <div class="pd_t t_o" v-if="info.teacherList.length">
      <div class="to_title">老师介绍</div>
      <div class="to_out">
        <div
          class="d_i to_item"
          v-for="(item,index) in info.teacherList"
          :key="index"
          @click="$router.push('/FacultyDetail?teacherId='+item.teacherId)"
        >
          <div class="d_f ali_c">
            <van-image fit="cover" :src="item.picUrl"/>
            <div class="name">
              <div>{{item.teacherName}}</div>
              <!--<div class="tn">职位</div>-->
            </div>
            <img src="../assets/img/pd_t_right.png" alt class="more">
          </div>
        </div>
      </div>
    </div>
    <div class="pd_t t_o bb_none">
      <div v-for="(item,index) in info.detailList" :key="index" class="mb_20 fu_list">
        <div class="to_title">{{item.title}}</div>
        <div v-html="item.commodityContent"></div>
      </div>
    </div>
    <div class="Appointment d_f ali_b j_s">
      <div class="num">剩余名额：<span>{{info.studentNum - info.guardianNum}}</span></div>
      <div class="btn" v-if="info.studentNum - info.guardianNum > 0" @click="show=true">预约试听</div>
    </div>
    <!-- 弹窗 -->
    <van-popup round closeable v-model:show="show">
      <div class="pop">
        <h5>预约试听</h5>
        <div>
          <label for>预约人姓名：</label>
          <input type="text" v-model="params.name">
          <div class="sex">
            <label for>预约人性别：</label>
            <van-radio-group v-model="params.sex" direction="horizontal">
              <van-radio name="1" checked-color="#ff8038" icon-size="16px">先生</van-radio>
              <van-radio name="2" checked-color="#ff8038" icon-size="16px">女士</van-radio>
            </van-radio-group>
          </div>
          <label for>联系人电话：</label>
          <input type="number" v-model="params.telephone">
        </div>
        <p class="btn" @click="submit">提交申请</p>
      </div>
    </van-popup>
    <!-- 弹窗二 -->
    <van-popup round closeable v-model:show="show2">
      <div class="pop">
        <h5>温馨提示</h5>
        <img src="../assets/images/success.png" alt>
        <span class="back" @click="backShow">立即返回</span>
        <p class="btn" @click="backIndex">返回首页</p>
      </div>
    </van-popup>

    <!-- <div class="bottom_btn p_f">
      <div class="price flex_1">
        ￥<span>{{info.sellPrice ? info.sellPrice/100 : 0}}</span>
      </div>
      <div class="btn" @click="showPop = true" v-if="showPopBtn">立即报名</div>
      <span v-else class="t_r no_stock">该商品暂无库存</span>
    </div>-->

    <!--点击立即报名后的弹窗-->
    <van-action-sheet v-model:show="showPop" title="选择研学时段" close-icon="clear">
      <div class="content">
        <div class="items">
          <div
            class="d_i item"
            v-for="(item,index) in stockArr"
            :key="index"
            :class="getClass(item,index)"
            @click="chooseStock(item,index)"
          >
            <div class="mb_5">{{item.startTime.split(' ')[0]+'——'+item.endTime.split(' ')[0]}}</div>
            <div v-if="item.stockNum > 0">
              剩余名额：仅剩
              <span>{{item.stockNum}}</span>名
            </div>
            <div v-else>名额已满</div>
          </div>
        </div>
        <div class="bottom_btn">
          <div class="price flex_1">
            ￥
            <span>{{info.sellPrice ? info.sellPrice/100 : 0}}</span>
          </div>
          <!--<div class="flex_1">
            已报名：<span>1212人</span>
          </div>-->
          <div class="btn" @click="sureOrder">确定报名</div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "ProductDetails",
  data() {
    return {
      showPop: false,
      showPopBtn: false,
      info: {teacherList:[],guardianNum:0,studentNum:0},
      stockArr: [],
      acStock: 0,
      show: false,
      show2: false,
      params: {
        courseId: 0,
        courseName: "",
        name: "",
        sex: "1",
        telephone: ""
      }
    };
  },
  created() {
    this.getCommodity();
    this.getCommodityStock();
  },
  methods: {
    isTel(value) {
      return /^1[3,4,5,6,7,8,9][0-9]{9}$/.test(value.toString());
    },
    // 预约试听表单提交
    submit() {
      if (this.params.name == "") {
        return this.$toast("请输入您的名字");
      } else if (!this.isTel(this.params.telephone)) {
        return this.$toast("请输入正确的电话号码");
      }
      this.$api.addAppointment(this.params).then(res => {
        if (res.status == 1) {
          this.show = false;

          this.getCommodity();
          this.getCommodityStock();
          this.show2 = true;
          if (this.show2) {
            setTimeout(() => {
              this.backShow();
            }, 5000);
          }
        }
      }).catch(() => {

        this.getCommodity();
        this.getCommodityStock();
      });
    },
    backShow() {
      this.show2 = false;
    },
    backIndex() {
      this.$router.push("/");
    },
    //确定报名
    sureOrder() {
      let commodityId = this.$route.query.commodityId;
      let stockId = this.stockArr[this.acStock].stockId;
      this.$router.push(
        "/FillOrder?commodityId=" + commodityId + "&stockId=" + stockId
      );
    },
    //库存样式
    getClass(row, index) {
      let str = "";
      if (row.stockNum > 0) {
        if (index == this.acStock) str = " ac";
      } else {
        str = " dis";
      }
      return str;
    },
    //点击库存
    chooseStock(row, index) {
      if (row.stockNum > 0) {
        this.acStock = index;
      }
    },
    //查询库存
    getCommodityStock() {
      this.$api
        .getCommodityStock({ commodityId: this.$route.query.commodityId })
        .then(res => {
          if (!res.data.length) {
            this.showPopBtn = false;
          } else {
            this.showPopBtn = true;
          }
          this.stockArr = JSON.parse(JSON.stringify(res.data));
        });
    },
    //查询商品详情
    getCommodity() {
      this.$api
        .getCommodity({ commodityId: this.$route.query.commodityId })
        .then(res => {
          console.log(res);

          this.info = res.data;
          this.params.courseId = res.data.commodityId;
          this.params.courseName = res.data.commodityName;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.no_stock {
  margin-right: 10px;
  line-height: 50px;
}
.fu_list {
  ::v-deep img {
    max-width: 100% !important;
    height: auto;
  }
  ::v-deep table {
    max-width: 100% !important;
  }
}
.items {
  .item {
    &.ac {
      background-color: #cefbff;
      color: #17c0cf;
    }
    &.dis {
      cursor: not-allowed;
      color: #c5c5c5;
    }
    cursor: pointer;
    padding: 6px 0;
    text-align: center;
    width: calc((100% - 21px) / 2);
    height: 50px;
    background: #ececec;
    border-radius: 3px;
    box-sizing: border-box;
    margin-bottom: 20px;
    &:nth-child(odd) {
      margin-right: 21px;
    }
  }
  max-height: 300px;
  overflow-y: auto;
  padding: 15px 13px 15px 13px;
}
.pd_t {
  .time {
    font-size: 12px;
    font-weight: 500;
    color: #909090;
  }
  .tag_out {
    .tag {
      display: block;
      font-size: 12px;
      font-weight: bold;
      color: #ffffff;
      width: 63px;
      height: 24px;
      line-height: 24px;
      border-radius: 1px;
      text-align: left;
      margin-right: 6px;
    }
    .flex_1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    margin-bottom: 14px;
    font-size: 15px;
    font-weight: bold;
    color: #3e3e3e;
  }
  .my-swipe {
    margin-bottom: 18px;
  }
  border-bottom: 4px solid #f5f5f5;
  padding: 0 13px 10px;
}
.t_o {
  &.bb_none {
    img {
      max-width: 100% !important;
    }
    border-bottom: none;
    padding-bottom: 60px;
  }
  .to_item {
    .more {
      width: 6px;
      height: 10px;
    }
    .name {
      .tn {
        margin-top: 8px;
        font-size: 12px;
        color: #8e8e8e;
      }
      margin-right: 15px;
      font-size: 13px;
      font-weight: 500;
      color: #3e3e3e;
    }
    .van-image,
    img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 8px;
      overflow: hidden;
    }
    margin-right: 10px;
  }
  .to_out {
    white-space: nowrap;
    overflow-x: auto;
  }
  .to_title {
    color: #3e3e3e;
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: bold;
  }
  padding-top: 17px;
}

.Appointment {
  .btn{
    height: 30px;
    line-height: 30px;
    color: #ff8038;
    background: white;
    border-radius: 15px;
    text-align: center;
    padding: 0 15px;
    font-size: 12px;
  }
  .num{
    position: relative;
    top: 8px;
    font-size: 10px;
    span{
      font-size: 20px;
    }
  }
  padding: 0 15px;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #ff8038;
  vertical-align: baseline;
  overflow: hidden;
}
.pop {
  width: 350px;
  height: 345px;
  background: #fff;
  img {
    display: block;
    width: 120px;
    margin: 20px auto 0;
  }
  .back {
    width: 96px;
    height: 26px;
    line-height: 26px;
    border: 1PX solid #ffc4a2;
    color: #ffc4a2;
    display: block;
    margin: 15px auto 0;
    text-align: center;
  }
  h5 {
    font-size: 16px;
    height: 57px;
    line-height: 57px;
    text-align: center;
    border-bottom: 1px solid #d0d0d0;
  }
  > div {
    width: 308px;
    margin: 19px auto 0;
  }
  label {
    display: block;
    font-size: 14px;
    margin-bottom: 6px;
  }
  input {
    border: 1PX solid #dddddd;
    border-radius: 3px;
    height: 35px;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .sex {
    display: flex;
    margin-bottom: 20px;
  }
  .btn {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    background: #24bddd;
    color: #fff;
    font-size: 18px;
    width: 100%;
    text-align: center;
  }
}
</style>
